// Último valor conhecido de leituras essenciais (sessão, caixa atual, cardápio, últimas vendas),
// para o PDV abrir e continuar vendendo mesmo se a página for recarregada sem internet.
import { ErroApi } from "../api/cliente";

const PREFIXO = "caixaflow:";

export function lembrar(chave: string, valor: unknown): void {
  try {
    localStorage.setItem(PREFIXO + chave, JSON.stringify(valor));
  } catch {
    // Armazenamento indisponível (aba anônima, cota): segue sem o recurso offline.
  }
}

export function lembrado<T>(chave: string): T | undefined {
  try {
    const texto = localStorage.getItem(PREFIXO + chave);
    return texto ? (JSON.parse(texto) as T) : undefined;
  } catch {
    return undefined;
  }
}

/** Apaga tudo o que foi lembrado (logout ou troca de usuário no aparelho). */
export function esquecerTudo(): void {
  try {
    for (const chave of Object.keys(localStorage)) if (chave.startsWith(PREFIXO)) localStorage.removeItem(chave);
  } catch {
    // idem
  }
}

/** Busca na API e lembra o resultado; sem conexão, devolve o último valor conhecido (se houver). */
export async function comUltimoConhecido<T>(chave: string, buscar: () => Promise<T>): Promise<T> {
  try {
    const valor = await buscar();
    lembrar(chave, valor);
    return valor;
  } catch (erro) {
    if (erro instanceof ErroApi && erro.codigo === "SEM_CONEXAO") {
      const guardado = lembrado<T>(chave);
      if (guardado !== undefined) return guardado;
    }
    throw erro;
  }
}
